import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import moment from "moment";
import { SearchInput } from "@/ui/inputs/Input";
import { PrimaryButton } from "@/ui/buttons/Button";
import useTableService from "../useTableServerSide";
import Footer from "../Footer";
import {
  Card,
  CardContent,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { Pie } from "react-chartjs-2";

import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { formatMoneda } from "@/util/varios";
import ModalReporteCompromiso from "./modalReporteCompromiso";
import { Compromisos } from "./modalCompromiso";
export default function TablaCompromisos(props) {
  const op = require("@/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const idefiscal = localStorage.getItem("idefiscal");
  const espiritu = localStorage.getItem("espiritu");
  const searchTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [chartLabels, setChartLabels] = useState([]);
  const [chartValues, setChartValues] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [backgroundColors, setBackgroundColors] = useState([]);
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [mostrarImprimir, setMostrarImprimir] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [compromiso, setCompromiso] = useState();
  const [cuentas, setCuentas] = useState();
  const [operacion, setOperacion] = useState(1);
  const [tipoReporte, setTipoReporte] = useState(
    "Total" | "Causados" | "Por Causar" | "Reversados",
  );
  const [cartas, setCartas] = useState({
    total_monto: 0,
    total_monto_reversado: 0,
    total_monto_x_causado: 0,
    total_monto_sin_causado: 0,
    total_cantidad: 0,
    total_cantidad_reversado: 0,
    total_cantidad_x_causado: 0,
    total_cantidad_sin_causado: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const cardsData = [
    {
      title: "Total Compromisos",
      cantidad: cartas.total_cantidad,
      monto: formatMoneda(
        cartas.total_monto.toString().replace(",", "").replace(".", ","),
      ),
      color: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setTipoReporte("Total");
        setMostrarImprimir(true);
      },
    },
    {
      title: "Compromisos Causados",
      cantidad: cartas.total_cantidad_sin_causado,
      monto: formatMoneda(
        cartas.total_monto_sin_causado
          .toString()
          .replace(",", "")
          .replace(".", ","),
      ),
      color: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setTipoReporte("Causados");
        setMostrarImprimir(true);
      },
    },
    {
      title: "Compromisos x Causar",
      cantidad: cartas.total_cantidad_x_causado || 0,
      monto: formatMoneda(
        (cartas.total_monto_x_causado || 0)
          .toString()
          .replace(",", "")
          .replace(".", ","),
      ),
      color: "linear-gradient(135deg, #0ba360 0%, #3cba92 100%)",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setTipoReporte("Por Causar");
        setMostrarImprimir(true);
      },
    },
    {
      title: "Compromisos Reversados",
      cantidad: cartas.total_cantidad_reversado,
      monto: formatMoneda(
        (cartas.total_monto_reversado || 0)
          .toString()
          .replace(",", "")
          .replace(".", ","),
      ),
      color: "linear-gradient(135deg, #ff512f 0%, #dd2476 100%)",
      icon: "fas fa-sync fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => {
        setTipoReporte("Reversados");
        setMostrarImprimir(true);
      },
    },
  ];
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "Nº",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CONCEPTO",
      textAlign: "left",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "PROVEEDOR",
      textAlign: "left",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "left",
    },
    {
      id: "5",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };
  const { TblContainer, TblHead, TblPagination } = useTableService(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );
  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "",
        data: chartValues,
        backgroundColor: backgroundColors,
        borderColor: "#ffffff",
        borderWidth: 2,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "rgba(0,0,0,0.8)",
        padding: 10,
        cornerRadius: 4,
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value}`;
          },
        },
      },
    },
  };
  const generateColors = (count) => {
    const colorsPalette = [
      "#3498DB",
      "#2ECC71",
      "#F39C12",
      "#9B59B6",
      "#E74C3C",
      "#1ABC9C",
      "#E67E22",
      "#95A5A6",
      "#34495E",
      "#16A085",
      "#27AE60",
      "#2980B9",
      "#8E44AD",
      "#2C3E50",
      "#D35400",
      "#C0392B",
      "#BDC3C7",
      "#7F8C8D",
      "#F1C40F",
      "#E67E22",
    ];
    return Array.from(
      { length: count },
      (_, i) => colorsPalette[i % colorsPalette.length],
    );
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };
  const buscarRegistros = () => {
    setChartLabels([]);
    setChartValues([]);
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
      idefiscal: idefiscal,
    };
    const endpoint = `${op.conexion}/api/presupuesto/registroscompromisos`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          const { rows, count, totales, grafica } = response.data;
          setRecords(rows);
          setTotalRecords(count);
          setCartas(totales);
          grafica.forEach((e) => {
            const { label, value } = e;
            setChartLabels((prevLabels) => [...prevLabels, label]);
            setChartValues((prevValues) => [...prevValues, value]);
            const colors = generateColors(grafica.length);
            setBackgroundColors(colors);
          });
        }
      })
      .catch((error) => {
        console.log(error);
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
  };
  const buscarComrpomisos = async ({ ope, idCompromiso }) => {
    setLoading(true);
    try {
      const resCompromiso = await axios.get(
        `${op.conexion}/api/presupuesto/seleccionarcompromiso?idefi=${idefiscal}&operacion=${ope}&&idcompro=${idCompromiso}&espiritu=${espiritu}`,
        {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      const dataCompromiso = resCompromiso.data;
      if (!dataCompromiso || dataCompromiso.length < 0) {
        setCompromiso();
        setCuentas();
      } else {
        setCompromiso(dataCompromiso[0]);
        setCuentas(dataCompromiso);
        setShowModal(true);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto:
          error.response?.data?.message ||
          "Error al cargar la información del proveedor",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const parametros = ({ ope, idCompromiso, reversado, status }) => {
    setOperacion(ope);
    if (ope > 1) {
      if (ope === 2) {
        if (reversado > 0) {
          setMensaje({
            mostrar: true,
            titulo: "Informacion.",
            texto: "El Compromiso ya fue Reversado",
            icono: "informacion",
          });
        } else if (status === 1) {
          setMensaje({
            mostrar: true,
            titulo: "Informacion.",
            texto: "El Compromiso ya fue Causado",
            icono: "informacion",
          });
        } else if (status === 2) {
          setMensaje({
            mostrar: true,
            titulo: "Informacion.",
            texto: "El Compromiso ya fue Pagado",
            icono: "informacion",
          });
        } else {
          buscarComrpomisos({ ope, idCompromiso });
        }
      } else if (ope === 3) {
        if (reversado > 0) {
          buscarComrpomisos({ ope, idCompromiso });
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Informacion.",
            texto: "Debe Reversar el Compromiso para poder Eliminarlo",
            icono: "informacion",
          });
        }
      } else {
        buscarComrpomisos({ ope, idCompromiso });
      }
    } else {
      setShowModal(true);
    }
  };
  const cerrar = () => {
    props.menu();
  };
  useEffect(() => {
    const cleanup = buscarRegistros();
    return () => {
      if (cleanup) cleanup();
    };
  }, [tableState]);
  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh" }}
    >
      <div className="row g-3 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-4 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-4 m-0">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h5
                    className="text-uppercase fw-extrabold mb-0"
                    style={{
                      letterSpacing: "1px",
                      fontSize: "1.1rem",
                      fontWeight: "800",
                    }}
                  >
                    {card.title}
                  </h5>
                  {card.print ? (
                    <div
                      style={{
                        marginTop: "-5px",
                        marginRight: "-10px",
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 10,
                      }}
                    >
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          card.print();
                        }}
                        className="btn btn-sm btn-light rounded-circle shadow-sm"
                        style={{
                          width: "35px",
                          height: "35px",
                          border: "none",
                        }}
                      >
                        <i className="fas fa-print text-dark" />
                      </button>
                    </div>
                  ) : (
                    <i className={`${card.icon} fs-4 opacity-75`}></i>
                  )}
                </div>
                <div className="d-flex flex-column gap-2">
                  <div className="d-flex align-items-center">
                    <span
                      className="small fw-bold opacity-75 text-uppercase"
                      style={{ fontSize: "0.75rem", width: "70px" }}
                    >
                      Cantidad:
                    </span>
                    <span
                      className="fw-bold"
                      style={{ lineHeight: "1", fontSize: "1rem" }}
                    >
                      {card.cantidad}
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span
                      className="small fw-bold opacity-75 text-uppercase"
                      style={{ fontSize: "0.75rem", width: "70px" }}
                    >
                      Monto:
                    </span>
                    <span
                      className="fw-bold"
                      style={{ lineHeight: "1", fontSize: "1rem" }}
                    >
                      {card.monto}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="row g-4">
        <div className="col-9">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white d-flex justify-content-between">
              <h5 className="mb-0 fw-bold text-uppercase">Compromisos</h5>
              <a
                onClick={() => cerrar()}
                type="button"
                className="text-light fw-bold fs-6"
                style={{ cursor: "pointer" }}
              >
                <i className="fas fa-times ms-2" />
              </a>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
                <div
                  onClick={() =>
                    parametros({
                      ope: 1,
                      idCompromiso: "",
                      reversado: "",
                      status: "",
                    })
                  }
                  className="col-auto mx-2 p-0"
                >
                  <PrimaryButton icon="fa-plus m-0 p-0" />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr key={index} style={{ padding: "0" }}>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "10px" }}
                          >
                            {item.idcompromiso}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "left", width: "auto" }}
                          >
                            {item.concepto}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "left", width: "auto" }}
                          >
                            {item.proveedor}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "50px" }}
                          >
                            {moment(item.fecha).format("DD-MM-YYYY")}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "100px" }}
                          >
                            {formatMoneda(
                              item.montocompromiso
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2,
                            )}
                          </td>
                          <td
                            className="align-baseline"
                            style={{ textAlign: "center", width: "125px" }}
                          >
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 4,
                                  idCompromiso: item.idcompromiso,
                                  reversado: item.reversado,
                                  status: item.status,
                                })
                              }
                              className="btn btn-sm mx-1 btn-info rounded-circle"
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 2,
                                  idCompromiso: item.idcompromiso,
                                  reversado: item.reversado,
                                  status: item.status,
                                })
                              }
                              className="btn btn-sm mx-1 btn-success rounded-pill"
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              onClick={() =>
                                parametros({
                                  ope: 3,
                                  idCompromiso: item.idcompromiso,
                                  reversado: item.reversado,
                                  status: item.status,
                                })
                              }
                              className="btn btn-sm mx-1 btn-danger rounded-circle"
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>
        <div className="col-3">
          <Card
            className="my-2"
            sx={{
              borderRadius: 4,
              boxShadow: 3,
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardContent
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                align="center"
                mb={1}
                color="text.secondary"
                style={{ textTransform: "uppercase" }}
              >
                Tipo de Compromisos
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  position: "relative",
                  width: "100%",
                  minHeight: "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {chartLabels.length > 0 ? (
                  <Pie data={chartData} options={chartOptions} />
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    No hay datos para mostrar
                  </Typography>
                )}
              </Box>
              {chartLabels.length > 0 && (
                <Box
                  sx={{
                    flexGrow: 0,
                    overflowY: "auto",
                    maxHeight: "40%",
                    mt: 1,
                  }}
                >
                  <List dense sx={{ py: 0 }}>
                    {chartLabels.map((label, index) => {
                      // Limpiar el label para mostrarlo
                      const cleanLabel = label.trim();
                      const total = chartValues.reduce((a, b) => a + b, 0);
                      const percentage = (
                        (chartValues[index] / total) *
                        100
                      ).toFixed(1);

                      return (
                        <React.Fragment key={cleanLabel}>
                          <ListItem
                            sx={{ px: 1, py: 0.5 }}
                            secondaryAction={
                              <Typography
                                variant="body2"
                                fontWeight="bold"
                                color="text.primary"
                              >
                                {chartValues[index]}
                              </Typography>
                            }
                          >
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                borderRadius: "50%",
                                backgroundColor: backgroundColors[index],
                                mr: 2,
                                flexShrink: 0,
                              }}
                            />
                            <ListItemText
                              style={{
                                textTransform: "uppercase",
                              }}
                              primaryTypographyProps={{
                                variant: "caption",
                                noWrap: true,
                                sx: { fontSize: "11px" },
                              }}
                              primary={cleanLabel}
                            />
                          </ListItem>
                          {index < chartLabels.length - 1 && (
                            <Divider component="li" />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </List>
                </Box>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Compromisos
        show={showModal}
        operacion={operacion}
        compro={compromiso}
        cuentas={cuentas}
        titulo={
          operacion === 4
            ? "Consulta Compromiso"
            : operacion === 2
              ? "Reversar Compromiso"
              : operacion === 1
                ? "Incluir Compromiso"
                : "Eliminar Compromiso"
        }
        onHideCancelar={() => setShowModal(false)}
        onHideRenderizar={() => buscarRegistros()}
      />
      <ModalReporteCompromiso
        show={mostrarImprimir}
        cancelar={() => setMostrarImprimir(false)}
        tipo={tipoReporte}
      />
      <Dimmer active={loading} inverted />
      <Footer />
    </div>
  );
}
